import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { routeConfig } from "@monorepo/constants/routeConfig";

import { useAppDispatch, useAppSelector } from "hooks";

export interface ILoginContext {
  phone?: string;
  setPhone: Dispatch<SetStateAction<string | undefined>>;
  secret?: string;
  setSecret: Dispatch<SetStateAction<string | undefined>>;
  question?: string;
  setQuestion: Dispatch<SetStateAction<string | undefined>>;
  isLoading?: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
}

export const LoginContext = createContext<ILoginContext>({} as ILoginContext);

export const LoginContextProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [phone, setPhone] = useState<string>();
  const [secret, setSecret] = useState<string>();
  const [question, setQuestion] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const token = useAppSelector((state) => state.authSlice.access_token);
  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (token) {
      setIsLoading(true);
      history.push(routeConfig.dashboard.payments.self);
      setIsLoading(false);
    }
  }, [token, history, dispatch]);

  const value = useMemo(
    () => ({ phone, setPhone, secret, setSecret, question, setQuestion, isLoading, setIsLoading }),
    [phone, secret, question, isLoading]
  );

  return <LoginContext.Provider value={value}>{children}</LoginContext.Provider>;
};
